import React from 'react';

const Error500 = () => {
  return (
    <div className="min-vh-100">
        <div className="bg-overlay bg-light"></div>
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="text-center py-5 mt-5">
                       <div className="position-relative">
                           <h1 className="fw-semibold display-4 mb-0">500</h1>
                            <h4 className="error-subtitle text-uppercase mb-0">Opps, something went wrong!</h4>
                       </div>
                        <div className="mt-4 text-center">
                            <a className="btn btn-primary" href="/app/dashboard">Back to Dashboard</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

  );
};

export default Error500;
